module.exports = "<div class=modal-header> <h3 class=\"modal-title text-center\" id=myModalLabel>{{object.title}}</h3> </div> <div class=\"modal-body text-center\"> <h4> {{object.message}} </h4> <br/> <div> <h5> {{object.detail}} </h5> </div> </div> <div class=\"modal-footer clear\"> <a class=\"btn btn-default\" ng-click=cancel()> <i class=\"fa fa-reply\"></i> {{ 'utils_notify.back' | translate }} </a> <a class=\"btn btn-success\" ng-click=delete()> <i class=\"fa fa-check\"></i> {{ 'utils_notify.confirm' | translate }} </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-utils-notify/services/notify/NotifyAction.html
// module id = 445
// module chunks = 0